import { render, staticRenderFns } from "./OutletSwitcher.vue?vue&type=template&id=25a843ae&"
import script from "./OutletSwitcher.vue?vue&type=script&lang=ts&"
export * from "./OutletSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports